import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import { AxiosError } from "axios";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import axios from "axios";
import { server } from "../../common";
import { useDispatch } from "react-redux";
import { Col, Row } from "react-bootstrap";

const initialValues = {
  name: "",
  contactno: "",
  email: "",
  password: "",
  otp: "",
  file: null,
  state: "",
  district: "",
  taluka: "",
  village: "",
  current_address: "",
  permanent_address: "",
  occupation: "",
  organization_name: "",
  blood_group: "",
  gender: "",
};

const StudentRegister = () => {
  document.title = "Register";
  const [step, setStep] = useState(0);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    resetForm,
    setFieldValue,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      name: Yup.string()
        .min(2, "Enter Full Name")
        .required("Please Enter Your Full Name"),
      // .optional(),
      current_address: Yup.string()
        .min(2, "Enter Education")
        .required("Please Enter Your Education"),
      // .optional(),
      permanent_address: Yup.string()
        .min(2, "Enter Year Of Education")
        .required("Please Enter Your Year Of Education"),
      // .optional(),
      occupation: Yup.string()
        .min(2, "Enter College Name")
        .required("Please Enter Your College Name"),
      organization_name: Yup.string()
        .min(2, "Enter College Name")
        .required("Please Enter Your College Name"),
      blood_group: Yup.string()
        .min(1, "Enter College Name")
        .required("Please Enter Your College Name"),
      gender: Yup.string()
        .min(2, "Enter College Name")
        .required("Please Enter Your College Name"),

      state: Yup.string()
        .min(2, "Enter Your State Name")
        .required("Please Enter Your Your State Name"),
      district: Yup.string()
        .min(2, "Enter District Name")
        .required("Please Enter Your District Name"),
      village: Yup.string()
        .min(2, "Enter Your Village Name")
        .required("Please Enter Your Your Village Name"),
      taluka: Yup.string()
        .min(2, "Enter Your Taluka Name")
        .required("Please Enter Your Your Taluka Name"),
      email: Yup.string()
        .email("Enter a valid email")
        .required("Please Enter Your Email"),
      contactno: Yup.string()
        .matches(/^[6-9]\d{9}$/, "Please enter a valid Indian mobile number")
        .required("Please enter your contact number"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
          "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
        )
        .required("Please Enter Your password"),

      file: Yup.mixed()
        .test("fileSize", "File size is too large", (value) => {
          // Check the file size (if required)
          // Modify the limit according to your requirements
          return value ? value.size <= 5000000 : true;
        })
        .optional(), // Make the file field optional
    }),

    onSubmit: (values) => {
      console.log(values);
      const formData = new FormData();
      if (values.file) {
        formData.append("file", values.file);
      }

      server
        .post("/register/studentregister", values, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (response) {
          console.log("api response", response.data);
          if (response.status === 200 || response.status === 201) {
            if (response.data) {
              toast.success("User Register successfully");
              navigate("/loginstudent");
              resetForm();
            }
          }
        })
        .catch(function (error) {
          if (error instanceof AxiosError && error.response?.data?.message)
            toast.error(error.response.data.message);
          else {
            toast.error(error.response.data.error);
          }
        });
    },
  });

  const sendOTPRequest = () => {
    const tst = toast.loading("Sending OTP", {
      theme: "colored",
      type: "info",
    });

    server
      .post("/otp/generate-otp", { email: values.email })
      .then((res) => {
        if (res.status === 200) {
          setOtpSent(true);
          toast.update(tst, {
            type: "success",
            render: res.data.message,
            isLoading: false,
            autoClose: 4000,
          });
        }
      })
      .catch((err) => {
        console.log(err.message);
        toast.update(tst, {
          type: "error",
          render: "Some Error Occurred",
          isLoading: false,
          autoClose: 4000,
        });
      });
  };

  const verifyOtp = (e) => {
    const tst = toast.loading("Verifying OTP", {
      theme: "colored",
      type: "info",
    });
    server
      .post("/otp/verify-otp", { email: values.email, otp: values.otp })
      .then((res) => {
        if (res.status === 200) {
          setOtpVerified(true);
          setStep(2);
        }
        toast.update(tst, {
          type: "success",
          render: res.data.message,
          isLoading: false,
          autoClose: 4000,
        });
      })
      .catch((err) => {
        console.log(err.message);

        toast.update(tst, {
          type: "error",
          render: err.response.data.message,
          isLoading: false,
          autoClose: 4000,
        });

        // toast.error("Some Error Occured");
      });
  };

  const sendOTP = () => {
    // Assuming you want to send OTP only if the email is valid
    if (!errors.email) {
      sendOTPRequest();
    }
  };

  return (
    <>
      {console.log(values)}
      {console.log(errors)}

      <section className="" style={{ marginTop: "1rem" }}>
        <div className="container py-5 ">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col col-xl-11">
              <div className="card" style={{ borderRadius: "1rem" }}>
                <div className="row g-0">
                  <div className="card-body p-4 p-lg-5 text-black">
                    <div>
                      <h5
                        className="fw-normal mb-3 pb-3 text-center text-uppercase"
                        style={{ letterSpacing: 1 }}
                      >
                        Create your account
                      </h5>
                      <form onSubmit={handleSubmit}>
                        <Row>
                          <Col>
                            <div className="mb-">
                              <TextField
                                name="name"
                                margin="dense"
                                type="text"
                                placeholder="Student Full Name"
                                variant="outlined"
                                label="Full Name "
                                value={values.name}
                                onChange={handleChange}
                                fullWidth
                                required
                              ></TextField>
                              {errors.name ? (
                                <p className="text-danger">{errors.name}</p>
                              ) : null}
                            </div>
                            <div className="">
                              <TextField
                                name="organization_name"
                                margin="dense"
                                type="text"
                                placeholder="Organisation Name"
                                variant="outlined"
                                label="Organisation Name"
                                value={values.organization_name}
                                onChange={handleChange}
                                fullWidth
                                required
                              ></TextField>
                              {errors.organization_name ? (
                                <p className="text-danger">
                                  {errors.organization_name}
                                </p>
                              ) : null}
                            </div>
                            <div className="">
                              <TextField
                                name="current_address"
                                margin="dense"
                                type="text"
                                placeholder="Current Address"
                                variant="outlined"
                                label="Current Address"
                                value={values.current_address}
                                onChange={handleChange}
                                fullWidth
                                required
                              ></TextField>
                              {errors.current_address ? (
                                <p className="text-danger">
                                  {errors.current_address}
                                </p>
                              ) : null}
                            </div>
                            <div className="">
                              <TextField
                                name="permanent_address"
                                margin="dense"
                                type="text"
                                placeholder="Permanant Address"
                                variant="outlined"
                                label="Permanant Address"
                                value={values.permanent_address}
                                onChange={handleChange}
                                fullWidth
                                required
                              ></TextField>
                              {errors.permanent_address ? (
                                <p className="text-danger">
                                  {errors.permanent_address}
                                </p>
                              ) : null}
                            </div>
                            <div className="">
                              <TextField
                                name="state"
                                margin="dense"
                                type="text"
                                placeholder="State"
                                variant="outlined"
                                label="State"
                                value={values.state}
                                onChange={handleChange}
                                fullWidth
                                required
                              ></TextField>
                              {errors.state ? (
                                <p className="text-danger">{errors.state}</p>
                              ) : null}
                            </div>
                            <div className="">
                              <TextField
                                name="district"
                                margin="dense"
                                type="text"
                                placeholder="District"
                                variant="outlined"
                                label="District"
                                value={values.district}
                                onChange={handleChange}
                                fullWidth
                                required
                              ></TextField>
                              {errors.district ? (
                                <p className="text-danger">{errors.district}</p>
                              ) : null}
                            </div>
                            <div className="">
                              <TextField
                                name="taluka"
                                margin="dense"
                                type="text"
                                placeholder="Taluka"
                                variant="outlined"
                                label="Taluka"
                                value={values.taluka}
                                onChange={handleChange}
                                fullWidth
                                required
                              ></TextField>
                              {errors.taluka ? (
                                <p className="text-danger">{errors.taluka}</p>
                              ) : null}
                            </div>
                            {/* <div>
                              <FormControl
                                fullWidth
                                required
                                className="mt-2 mb-1"
                              >
                                <InputLabel id="demo-simple-select-label">
                                  Employeed
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  label="Employeed"
                                  variant="outlined"
                                  name="employed"
                                  value={values.employed}
                                  onChange={handleChange}
                                  required
                                >
                                  <MenuItem value="Yes">Yes</MenuItem>
                                  <MenuItem value="No">No</MenuItem>
                                </Select>
                                {errors.employed ? (
                                  <p className="text-danger mb-0">
                                    {errors.employed}
                                  </p>
                                ) : null}
                              </FormControl>
                            </div> */}
                          </Col>
                          <Col>
                            <Row>
                              <Col md={10}>
                                <div className="">
                                  <TextField
                                    name="email"
                                    margin="dense"
                                    type="email"
                                    placeholder="example@gmail.com"
                                    variant="outlined"
                                    label="Email Id"
                                    value={values.email}
                                    onChange={handleChange}
                                    fullWidth
                                    required
                                  ></TextField>
                                  {errors.email ? (
                                    <p className="text-danger">
                                      {errors.email}
                                    </p>
                                  ) : null}
                                </div>
                              </Col>
                              <Col md={2}>
                                <button
                                  // style={{ fontSize: "13px", width: "6rem" }}
                                  className="mt-2 btn btn-primary text-white p-1 border-0 rounded-3 btn-sm"
                                  type="submit"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    sendOTPRequest();
                                  }}
                                  // disabled={otpSent} // Disable button if OTP has already been sent
                                >
                                  {otpSent ? "Resend OTP" : "Send OTP"}
                                </button>
                              </Col>
                            </Row>
                            {otpSent && !otpVerified && (
                              <Row>
                                <Col md={10}>
                                  <div className="">
                                    <TextField
                                      name="otp"
                                      margin="dense"
                                      type="text"
                                      placeholder="Enter OTP"
                                      variant="outlined"
                                      label="OTP"
                                      onChange={handleChange}
                                      fullWidth
                                      required
                                    />
                                  </div>
                                </Col>
                                <Col md={2}>
                                  <button
                                    className="mt-3 btn btn-success text-white border-0 rounded-3 align-self-center"
                                    type="submit"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      verifyOtp(true);
                                    }}
                                  >
                                    Verify
                                  </button>
                                </Col>
                              </Row>
                            )}

                            {otpVerified && (
                              <div className="">
                                <TextField
                                  name="password"
                                  margin="dense"
                                  type={showPassword ? "text" : "password"}
                                  placeholder="Password"
                                  variant="outlined"
                                  label="Password"
                                  value={values.password}
                                  onChange={handleChange}
                                  fullWidth
                                  required
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton
                                          onClick={handleTogglePassword}
                                          edge="end"
                                        >
                                          {showPassword ? (
                                            <i className="far fa-eye-slash"></i>
                                          ) : (
                                            <i className="far fa-eye"></i>
                                          )}
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </div>
                            )}
                            <div className="">
                              <FormControl
                                fullWidth
                                required
                                className="mt-2 mb-1"
                              >
                                <InputLabel id="demo-simple-select-label">
                                  Occupation
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  label="Gender"
                                  variant="outlined"
                                  name="occupation"
                                  value={values.occupation}
                                  onChange={handleChange}
                                  required
                                >
                                  <MenuItem value="Student">Student</MenuItem>
                                  <MenuItem value="Gov Employee">
                                    Gov Employee
                                  </MenuItem>
                                  <MenuItem value="Retired">Retired</MenuItem>
                                  <MenuItem value="Private Emp">
                                    Private Emp
                                  </MenuItem>
                                  <MenuItem value="Unemployed">
                                    Unemployed
                                  </MenuItem>
                                  <MenuItem value="Other">Other</MenuItem>
                                </Select>
                                {errors.occupation ? (
                                  <p className="text-danger mb-0">
                                    {errors.occupation}
                                  </p>
                                ) : null}
                              </FormControl>
                            </div>
                            <div>
                              <FormControl
                                fullWidth
                                required
                                className="mt-2 mb-1"
                              >
                                <InputLabel id="demo-simple-select-label">
                                  Gender
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  label="Gender"
                                  variant="outlined"
                                  name="gender"
                                  value={values.gender}
                                  onChange={handleChange}
                                  required
                                >
                                  <MenuItem value="Male">Male</MenuItem>
                                  <MenuItem value="Female">Female</MenuItem>
                                </Select>
                                {errors.gender ? (
                                  <p className="text-danger mb-0">
                                    {errors.gender}
                                  </p>
                                ) : null}
                              </FormControl>
                            </div>

                            <div className="">
                              <TextField
                                name="contactno"
                                margin="dense"
                                type="text"
                                placeholder=" Contact Number (Whatsapp)"
                                variant="outlined"
                                label=" Contact Number"
                                value={values.contactno}
                                onChange={handleChange}
                                fullWidth
                                required
                              ></TextField>
                              {errors.contactno ? (
                                <p className="text-danger">
                                  {errors.contactno}
                                </p>
                              ) : null}
                            </div>
                            <div className="">
                              <TextField
                                name="blood_group"
                                margin="dense"
                                type="text"
                                placeholder="Blood Group"
                                variant="outlined"
                                label="Blood Group"
                                value={values.blood_group}
                                onChange={handleChange}
                                fullWidth
                                required
                              ></TextField>
                              {errors.blood_group ? (
                                <p className="text-danger">
                                  {errors.blood_group}
                                </p>
                              ) : null}
                            </div>
                            <div className="">
                              <TextField
                                name="village"
                                margin="dense"
                                type="text"
                                placeholder="Village"
                                variant="outlined"
                                label="Village"
                                value={values.village}
                                onChange={handleChange}
                                fullWidth
                                required
                              ></TextField>
                              {errors.village ? (
                                <p className="text-danger">{errors.village}</p>
                              ) : null}
                            </div>
                          </Col>
                        </Row>

                        <div className="mb-2">
                          <label htmlFor="">Profile Photo</label>
                          <input
                            name="file"
                            margin="dense"
                            type="file"
                            className="form-control"
                            onChange={(event) => {
                              setFieldValue(
                                "file",
                                event.currentTarget.files[0]
                              );
                            }}
                            fullWidth
                            required
                          />
                          {errors.file ? (
                            <p className="text-danger">{errors.file}</p>
                          ) : null}
                        </div>
                        <div className="text-center">
                          <button
                            className="banner border-0 p-2 mt-2 w-100 rounded-5 text-white "
                            type="submit"
                          >
                            Register
                          </button>
                          <p className="mt-2">
                            I already have an account ?
                            <NavLink to="/loginstudent"> Login</NavLink>
                          </p>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default StudentRegister;
